"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "andorno-micca": {
    "1412b854": [{
      "hkey": "54729b4e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cacciorna": [{
      "hkey": "54729b4e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d6377450": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "skipSearch": false
    }],
    "locato-inferiore": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c68332e1": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "skipSearch": false
    }],
    "locato-superiore": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33eb1308": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "skipSearch": false
    }],
    "lorazzo-superiore": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9db0113": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "skipSearch": false
    }],
    "ravizza": [{
      "hkey": "1da03564",
      "slug": "andorno-micca",
      "name": "Andorno Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ddba452c": [{
      "hkey": "54729b4e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "andorno-cacciorna": [{
      "hkey": "54729b4e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bbaf1839": [{
      "hkey": "65439869",
      "slug": "locato-superiore-ravizza-cerruti",
      "name": "Locato Superiore-Ravizza-Cerruti",
      "primary": true,
      "skipSearch": false
    }],
    "cerruti": [{
      "hkey": "65439869",
      "slug": "locato-superiore-ravizza-cerruti",
      "name": "Locato Superiore-Ravizza-Cerruti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;